const apiList = {
	User: {
        login: ['user/login', 'username', 'password'],
        wxLoginQrcode: ['user/wx-login-qrcode', 'type', 'receiver_id'],
        getUserByPhone: ['user/get-user-by-phone', 'phone'],
        list: ['user/list', 'page', 'page_size', 'phone'],
        detail: ['user/detail'],
        delete: ['user/delete', 'id'],
        add: ['user/add', 'phone', 'password', 'code'],
        addByphone: ['user/add-by-phone', 'phone'],
        passwordUpdate: ['user/password-update', 'old_password', 'password'],
    },
    Project: {
        save: ['project/save', 'id', 'name'],
        list: ['project/list', 'page', 'name'],
        detail: ['project/detail', 'id'],
        delete: ['project/delete', 'id'],
        nameList: ['project/list-name']
    },
    Alarm: {
        list: ['alarm/list', 'page', 'project_id', 'model_id', 'time_begin', 'time_end'],
    },
    AlarmModel: {
        list: ['alarm-model/list', 'page', 'project_id'],
        save: ['alarm-model/save', 'id', 'project_id', 'name', 'uid', 'description', 'interval', 'level', 'publish_type'],
        delete: ['alarm-model/delete', 'id'],
        nameList: ['alarm-model/list-name', 'project_id'],
    },
    Receiver: {
        save: ['receiver/save', 'name', 'phone', 'email', 'wx_open_id'],
        list: ['receiver/list', 'page', 'page_size', 'phone'],
        listAll: ['receiver/list-all', 'phone', 'alarm_model_id'],
        delete: ['receiver/delete', 'id'],
        update: ['receiver/update', 'id', 'name', 'phone', 'email'],
        bindReceiver: ['receiver/bind-receiver', 'model_id', 'receiver_id'],
        unbindReceiver: ['receiver/unbind-receiver', 'model_id', 'receiver_id'],
    },
    Common: {
        phoneVerificationCodeSend: ['user/phone/send-code', 'phone']
    }
}

export default apiList
